import React, { Component, useEffect } from 'react';
import {useState} from 'react';
import {nanoid} from 'nanoid';
import NotesList from './components/NotesList';
import Search from './components/Search';
import Header from './components/header';
function UserHome() {
    const [notes, setNotes]=useState([
        {
            id:nanoid(),
            text:"Note1",
            date:"20/10/2021"
        },
        {
            id:nanoid(),
            text:"Note2",
            date:"20/10/2021"
        },
        {
            id:nanoid(),
            text:"Note3",
            date:"20/10/2021"
        },
        {
            id:nanoid(),
            text:"Note4",
            date:"20/10/2021"
        }
    ])

    const [searchText, setSearchText] = useState('');
    const [darkMode, setDarkMode] = useState(false);

    useEffect(()=>{
        const savedNotes = 
        JSON.parse(localStorage.getItem('qwigo-app-data')
        );
        if(savedNotes)
        {
            setNotes(savedNotes);
        }
    }, []);

    useEffect(()=>
    {
        localStorage.setItem(
            'qwigo-app-data',
            JSON.stringify(notes)
        );
    }, [notes]);

    const addNote=(text)=>
    {
        const date = new Date();
        const newNote = 
        {
            id: nanoid(),
            text: text,
            date: date.toLocaleDateString()
        }
        const newNotes = [...notes, newNote];
        setNotes(newNotes);
    }
    const deleteNote=(id)=>
    {
        const newNotes = notes.filter((note)=>note.id!==id);
        setNotes(newNotes);
    }
    return ( 
        <div className={`${darkMode && 'dark-mode'}`}>
        <div className="container">
            <Header handleToggleDarkMode={setDarkMode}/>
            <Search handleSearchNote={setSearchText}/>
            <NotesList
                notes={notes.filter((note)=>
                    note.text.toLowerCase().includes(searchText.toLowerCase()))}
                handleAddNote={addNote}
                handleDeleteNote={deleteNote}
            />
        </div>
        </div>
     )
}

export default UserHome;